import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api, fileUrl } from "../../lib/api";
import { ChatRoom } from "../CorrChat";
import { useAuth } from "../../context/AuthContext";

const adapter = {
  load: (tid, since) => api.correspondenceMessages(tid, since),
  send: (tid, b) => api.sendCorrespondenceMessage(tid, b),
  upload: (f) => api.uploadFile(f),
  urlFor: (id) => fileUrl(id),
  del: (mid) => api.deleteCorrMessage(mid),
};

export const EmployeeCorrTab = ({ employee }) => {
  const { user } = useAuth() || {};
  const [tid, setTid] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.createCorrespondenceThread({ employee_ids: [employee.id], subject: "", body: "" })
      .then((r) => setTid(r.id)).catch((e) => setErr(e?.response?.data?.detail || "تعذّر فتح المحادثة"));
  }, [employee.id]);
  if (err) return <p className="py-10 text-center text-sm text-rose-600" data-testid="emp-corr-error">{err}</p>;
  if (!tid) return <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  const sub = ["موظف", employee.phone].filter(Boolean).join(" · ");
  return (
    <div className="h-[60vh] min-h-[420px] overflow-hidden rounded-2xl border border-slate-200" data-testid="emp-corr-tab">
      <ChatRoom threadId={tid} adapter={adapter} actAs={["manager", "hr_manager"].includes(user?.role)} title={employee.name} subtitle={sub} group={false} />
    </div>
  );
};
